'use strict';

module.exports.Spectrum = require('./Spectrum');

module.exports.getPeaks = require('./getPeaks');
module.exports.getBestPeaks = require('./getBestPeaks');
